/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */

/* eslint-disable no-param-reassign,no-restricted-syntax */
import { v4 as uuid } from "uuid";
import {
  TransformObjectData,
  UntaggedTransformObjectData,
} from "@advapacs/common";
import {
  DATE_AND_TIME_RANGE,
  DATE_RANGE,
  SCRIPT,
  TIME_RANGE,
  BETWEEN_DATE_AND_TIME_INTERVAL,
  BETWEEN_DATE_INTERVAL,
  BETWEEN_TIME_INTERVAL,
  DYNAMIC,
} from "../../constant";

export const stripTags = (rules: UntaggedTransformObjectData[]): void => {
  for (const item of rules) {
    delete item.id;
    delete item?.transform?.annotations; // For DICOM

    if (
      item?.dynamic &&
      (item?.dynamic?.operator === DATE_RANGE ||
        item?.dynamic?.operator === TIME_RANGE ||
        item?.dynamic?.operator === DATE_AND_TIME_RANGE ||
        item?.dynamic?.operator === BETWEEN_DATE_INTERVAL ||
        item?.dynamic?.operator === BETWEEN_TIME_INTERVAL ||
        item?.dynamic?.operator === BETWEEN_DATE_AND_TIME_INTERVAL)
    ) {
      // exceptional case
      item.dynamic.value = `${item?.dynamic?.from},${item?.dynamic?.to}`;

      if (item) {
        delete item.dynamic.from;
        delete item.dynamic.to;
      }
    }
  }
};

export const addTags = (rules: TransformObjectData[]): void => {
  for (const item of rules) {
    item.id = uuid();

    if (item?.dynamic) {
      item.type = DYNAMIC;

      if (
        item?.dynamic?.operator === DATE_RANGE ||
        item?.dynamic?.operator === TIME_RANGE ||
        item?.dynamic?.operator === DATE_AND_TIME_RANGE ||
        item?.dynamic?.operator === BETWEEN_DATE_INTERVAL ||
        item?.dynamic?.operator === BETWEEN_TIME_INTERVAL ||
        item?.dynamic?.operator === BETWEEN_DATE_AND_TIME_INTERVAL
      ) {
        // exceptional case
        const range = (item?.dynamic?.value || "")?.split(",");
        delete item.dynamic.value;
        if (range && range.length === 2) {
          [item.dynamic.from] = range;
          [, item.dynamic.to] = range;
        }
      }
    }
  }
};

export const existScriptInTransformBuilderRule = (
  transformBuilderRules: UntaggedTransformObjectData[]
): boolean => {
  const existScriptInTransforms = transformBuilderRules.find(
    (x) => x.type === SCRIPT
  );

  return !!existScriptInTransforms;
};

export const checkValidatePeriod = (value: string): boolean => {
  if (!value) return false;
  return !!["Y", "M", "W", "D"].find(
    (x) =>
      value.toUpperCase().indexOf(x) > -1 &&
      value.toUpperCase().indexOf("T") === -1
  );
};
